import { inject, Injectable } from '@angular/core';
import { RegisterRestService } from '../../_generated';

@Injectable({
    providedIn: 'root',
})
export class RegisterService {
    private readonly registerRestService = inject(RegisterRestService);

    checkIdentificationCode(identificationCode: string) {
        return this.registerRestService.registerControllerCheckIdentificationCode({
            identificationCode,
        });
    }

    register(idToken: string) {
        return this.registerRestService.registerControllerRegister({
            idToken,
        });
    }
}
